import React, { useState } from 'react'
import styles from './styles.module.css'

function EmailsExpandedRecord({ record }) {
  const [isExpanded, setIsExpanded] = useState(false)

  // Toggle expand/collapse state
  const toggleExpand = () => {
    setIsExpanded(!isExpanded)
  }

  // Limit the display of emails to 5 unless expanded
  const emailsToShow = isExpanded
    ? record.emails
    : record.emails?.slice(0, 5) || []

  return (
    <div className={styles.EmailsExpandedRecordContainer}>
      <span className={styles.EmailsExpandedRecordTitle}>Emails</span>

      <div className={styles.EmailsExpandedRecordList}>
        {emailsToShow.length > 0 ? (
          emailsToShow.map((email, index) => (
            <span key={index} className={styles.EmailsExpandedRecordItem}>
              {email}
            </span>
          ))
        ) : (
          <span className={styles.NoEmailsExpandedRecord}>N/A</span>
        )}
      </div>

      {/* Show the expand button only if there are more than 5 emails */}
      {record.emails && record.emails.length > 5 && (
        <button
          className={styles.EmailsExpandedRecordButton}
          onClick={toggleExpand}
        >
          {isExpanded ? 'Show less' : `Expand all (${record.emails.length})`}
        </button>
      )}
    </div>
  )
}

export default EmailsExpandedRecord
